import React from 'react'

const PageTitle = (props) => {
  return (
    <div className='pagetitle'>
        <h1>{props.Title}</h1>
        <p>{props.Content}</p>
    </div>
  )
}

export default PageTitle;